import * as React from "react";
import { useAppPreviewGalleryButtonDisplayStyles } from "./useAppPreviewGalleryButtonDisplayStyles.styles";
import { useAppPreviewGalleryButtonDisplay } from "./useAppPreviewGalleryButtonDisplay";
import type { AppPreviewGalleryButtonDisplayProps } from "./AppPreviewGalleryButtonDisplay.types";
import { renderAppPreviewGalleryButtonDisplay } from "./renderAppPreviewGalleryButtonDisplay";

export const AppPreviewGalleryButtonDisplay = React.memo(
  React.forwardRef<HTMLDivElement, AppPreviewGalleryButtonDisplayProps>(
    (props, ref) => {
      const state = useAppPreviewGalleryButtonDisplay(props, ref);

      useAppPreviewGalleryButtonDisplayStyles(state);

      return renderAppPreviewGalleryButtonDisplay(state);
    }
  )
);

AppPreviewGalleryButtonDisplay.displayName =
  "next/AppPreviewGalleryButtonDisplay";

export type AppPreviewGalleryButtonDisplay =
  typeof AppPreviewGalleryButtonDisplay.prototype;
